export interface CatalogItem {
    id: string;
    name: string;
}

export interface OrderPricing {
    id: string;
    billing_currency: string;
    base_one_time_price: number;
    base_recurring_price: number;
    total_recurring_price: number;
    duration: number;
    discount: number;
    product_name: string;
    catalog_item: CatalogItem;
}


// Details
export interface DealerR {
    Business_Model__c: string;
    MakerAccountNumber__c: string;
}

export interface NEOrderIdR {
    Id: string;
    Name: string;
    Order_Duration__c: number;
    CreatedDate: Date;
    NE__OrderStatus__c: string;
    Technical_Status__c: string;
    Dealer__r: DealerR;
    NE__One_Time_Fee_Total__c: number;
    CurrencyIsoCode: string;
}

export interface NECatalogItemR {
    NE__Id__c: string;
    Name: string;
}

export interface NEServicePointR {
    Vehicle_Id_Number__c: string;
    Plate_Number__c?: any;
    Brand__c: string;
    Model__c: string;
    Color__c: string;
    Id: string;
    Cross_Platform_Identifier_c__c: string;
    Main_Driver__c: string;
    VA_RegistrationCountryIsoCode__c?: any;
}

export interface OrderDetails {
    NE__OrderId__r: NEOrderIdR;
    NE__ProdName__c: string;
    NE__CatalogItem__r: NECatalogItemR;
    NE__Cart_Description__c: string;
    NE__Service_Point__r: NEServicePointR;
    CurrencyIsoCode?: any;
    is_price_synced: boolean;
    is_automatic_renewal_available?: boolean;
    automatic_renewal_status?: string;
    automatic_renewal?: boolean;
    option_items: any[];
}

export interface OrderCard {
    description: string;
    id: string;
    message?: string;
    name: string;
    status: string;
    type: string;
    notice_parameters: any;
}
export interface OrderCards {
    cards: OrderCard[];
}

export interface PaymentMethod {
    automatic_renewal: boolean;
    id: string;
    payment_method_type: string;
    payment_method_code: string;
    stripe?: boolean;
    selectable?: boolean;
}

export interface Iban {
    account_holder_name: string;
    bic: string;
    country: string;
    iban: string;
}

export interface FinancialAddress {
    iban: Iban;
    supported_networks: string[];
    type: string;
}

export interface StripeBankTransferInstructions {
    amount_remaining: number;
    currency: string;
    financial_addresses: FinancialAddress[];
    hosted_instructions_url: string;
    reference: string;
    type: string;
}

export const paymentOptions: any = {
    card: {
        terms: {
            card: 'never',
            sepaDebit: 'never'
        }
    },
    customer_balance: {
        terms: {
            card: 'never',
            sepaDebit: 'never'
        },
        fields: {
            billingDetails: {
                email: 'never'
            }
        }
    },
    sepa_debit: {
        terms: {
            card: 'never',
            sepaDebit: 'never'
        },
        paymentMethodOrder: ['sepa_debit']
    }
}
